import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { getPoppularNews } from './actions'
import './stylePopular.css'
import ReactSwipe from 'react-swipe'
import Dialog from 'material-ui/Dialog'

import {GridList, GridTile} from 'material-ui/GridList';
import {CardTitle} from 'material-ui/Card';
import IconButton from 'material-ui/IconButton';
import Subheader from 'material-ui/Subheader';
import StarBorder from 'material-ui/svg-icons/toggle/star-border';
import Paper from 'material-ui/Paper';
import SessionHeader from '../../components/SessionHeader/SessionHeader'
import ButtonFavorite from '../../components/ButtonFavorite'

import language from '../../config/language'

const styles = {
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    width: '100%'
  },
  gridList: {
    width: '100%',
    display: 'flex',
    flexWrap: 'nowrap',
    overflowX: 'auto',
  },
};

 class NewsPopularContainer extends Component {
  state = {
    isOpenNewsDialog: false,
  }

  handleOpenNewsDialog = () => {
    this.setState({isOpenNewsDialog: true});
  }

  handleCloseNewsDialog = () => {
    this.setState({isOpenNewsDialog: false});
  }

  componentDidMount() {
    this.props.getPoppularNews();
    this.handleOpenNewsDialog();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.props.lang) {
      this.props.getPoppularNews()
    }
  }

  renderNewsDialog() {
    const {
      update,
      view
    } = language[this.props.lang].news.popular
    const tile = this.props.popular[Math.random() * this.props.popular.length | 0];
    return (
      <Dialog
        modal={false}
        contentStyle={{width: '95%', maxWidth: 'none'}}
        open={this.state.isOpenNewsDialog}
        onRequestClose={this.handleCloseNewsDialog}
        autoScrollBodyContent={true}
      >
        <GridTile
          style={{
            height: 200,
            borderRadius: 3
          }}
          titleBackground="linear-gradient(to top, rgba(0,0,0,0.7) 0%,rgba(0,0,0,0.3) 70%,rgba(0,0,0,0) 100%)"
          // titleBackground="linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(255, 255, 255, 0)"
          containerElement={<Link to={'/details/popularNews/'+tile.id} />}
          key={tile.img}
          title={<b>{tile.title}</b>}
          titleStyle={{ fontSize: 17 }}
          subtitle={
            <p style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginRight: 16 }}>
              <span>{update} <b>{tile.updated.toString().split(' ')[0]}</b></span>
              <span><b>{tile.viewed}</b> {view}</span>
            </p>
          }
        >
          <img src={tile.cover_photo} />
        </GridTile>
      </Dialog>
    )
  }

  renderContent() {
    
    const {
      update,
      view
    } = language[this.props.lang].news.popular
    if (this.props.error) {
      return <p>{language[this.props.lang].system.incorrect}</p>
    }
    if (this.props.popular.length) {
      return (
        <div style={{ paddingLeft: 5, paddingRight: 5 }}>
          <ReactSwipe
            className="carousel"
            swipeOptions={{
              speed: 400,
              auto: 2000,
              continuous: true
            }}>
              {this.props.popular.slice(0, 4).map((tile) => (
                <GridTile
                  style={{
                    height: 200,
                    borderRadius: 3
                  }}
                  titleBackground="linear-gradient(to top, rgba(0,0,0,0.7) 0%,rgba(0,0,0,0.3) 70%,rgba(0,0,0,0) 100%)"
                  // titleBackground="linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(255, 255, 255, 0)"
                  containerElement={<Link to={'/details/popularNews/'+tile.id} />}
                  key={tile.img}
                  title={<b>{tile.title}</b>}
                  titleStyle={{ fontSize: 17 }}
                  subtitle={
                    <p style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginRight: 16 }}>
                      <span>{update} <b>{tile.updated.toString().split(' ')[0]}</b></span>
                      <span><b>{tile.viewed}</b> {view}</span>
                    </p>
                  }
                >
                  <img src={tile.cover_photo} />
                </GridTile>
              ))}
          </ReactSwipe>
          {this.renderNewsDialog()}
        </div>
      )
    }
  }
  render() {
    const {
      title,
      loading,
      seemore
    } = language[this.props.lang].news.popular
    return (
      <Paper zDepth={1} style={{ padding: 5, paddingBottom: 10 }}>
        <SessionHeader
          title={title}
          titleColor=''
          textSeemore={seemore}
          lineSeemore={'/home/news'}
        />
        {
          this.props.loading
          ? <p>{loading}</p>
          : this.renderContent()
        }
      </Paper>
    )
  }
}

const mapStateToProps = ({ lang, category,...state }) => ({
  popular: state.news.popular[lang].data,
  loading: state.news.popular.loading,
  lang,
  category
})
export default connect(mapStateToProps, { getPoppularNews }
)(NewsPopularContainer)




// WEBPACK FOOTER //
// ./src/containers/News/NewsPopularContainer.js